import { createFileRoute } from '@tanstack/react-router'
import ContactFiles from '@Views/Contacts/Contacts/ContactDetails/ContactFiles'

export const Route = createFileRoute('/contacts/$contactId_/files')({
  component: ContactFiles,
})
